import {
  LoanStatus,
  Requirement,
  RequirementDataMap,
  RequirementName,
  StateRequirementStatus,
  WorkflowState,
} from '~/models/WorkflowState';

export const getActiveRequirement = <TName extends RequirementName>(
  workflowState: WorkflowState | undefined,
  name: TName
): Requirement<RequirementDataMap[TName]> | undefined => {
  if (workflowState?.loanStatus !== LoanStatus.ACTION_REQUIRED) return undefined;

  const [firstRequirement] = workflowState.requirements;
  if (firstRequirement?.name !== name) return undefined;

  return firstRequirement as Requirement<RequirementDataMap[TName]>;
};

export const isRequirementPending = (
  workflowState: WorkflowState | undefined,
  requirementName: RequirementName
): boolean => {
  const requirement = workflowState?.requirements?.find((r) => r.name === requirementName);
  return requirement?.status === StateRequirementStatus.PENDING;
};
